<template>
  <div>
    <!--    <TopMenu></TopMenu>-->
    <div class="box">
      <!-- body 左侧树型列表 -->
      <el-card class="card-float left-card">
        <div>
          <el-button type="primary" size="mini" @click="newFolder">+ 创建文件夹</el-button>
          <el-tree
            class="slot-tree"
            draggable
            :data="treeData"
            default-expand-all
            node-key="id"
            @node-contextmenu="rightClick"
            @node-click="leftClick"
            ref="tree"
            accordion
          >
            <!--
            node : 当前节点的 Node 对象
            data : 当前节点的数据
            -->
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <!--文本框-->
              <span v-show="!node.isEdit">
                <el-image
                  style="width: 15px;height: 15px"
                  :src="node.expanded?require('@/assets/dir_open.png'):require('@/assets/dir_close.png')"
                  v-show="data.children && data.children.length >= 1"
                ></el-image>
                <span>{{node.label}}</span>
              </span>
              <!--编辑框 用于新建文件夹-->
              <span v-show="node.isEdit">
                <el-input
                  size="mini"
                  :ref="'slotTreeInput'+data.id"
                  v-model="data.label"
                  @blur.stop="nodeBlur(node, data)"
                  @keyup.enter.native="nodeBlur(node, data)"
                ></el-input>
              </span>
            </span>
          </el-tree>
        </div>
      </el-card>
      <!-- body右边列表 -->
      <el-card class="card-float right-card">
        <div>
          <div>
            <el-button size="mini" type="primary" @click="addAcount">+ 登记密码</el-button>
          </div>
          <div>
            <el-table :data="tableData" stripe>
              <el-table-column type="index" label="序号"></el-table-column>
              <el-table-column prop="accountType" label="账号类型"></el-table-column>
              <el-table-column prop="account" label="账号"></el-table-column>
              <el-table-column prop="password" label="密码" width="100">
                <template slot-scope="scope">
                  <div style="display: flex;flex-flow: row;flex-wrap: nowrap">
                    <span>{{visiableIds.indexOf(scope.row.id)!=-1?scope.row.account:"*****"}}</span>
                    <el-image
                      style="width: 20px;height: 20px;margin-left: 2px"
                      :src="visiableIds.indexOf(scope.row.id)!=-1?require('@/assets/pwd_visiable.png'):require('@/assets/pwd_unvisiable.png')"
                      @click="plaintext(scope.row)"
                    />
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="usage" label="使用情况"></el-table-column>
              <el-table-column prop="dueTime" label="到期时间"></el-table-column>
              <el-table-column prop="balance" label="账户余额"></el-table-column>
              <el-table-column prop="updateTime" label="更新时间"></el-table-column>
              <el-table-column prop="updater" label="更新人"></el-table-column>
              <el-table-column prop="mark" label="备注信息"></el-table-column>
              <el-table-column label="操作" width="100px">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="editItem(scope.row)">编辑</el-button>
                  <el-button type="text" size="small" @click="delItem(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <pagination class="pagination" :pageTotal="pageTotal" :pageSize="pageSize" />
          </div>
        </div>
      </el-card>
      <!--右击菜单栏-->
      <div v-show="menuVisiable" id="rightClickMenu">
        <el-card>
          <el-menu class="el-menu" @select="menuSelect">
            <el-menu-item index="1" class="el-menu-item">添加子节点</el-menu-item>
            <el-menu-item index="2" class="el-menu-item">修改名称</el-menu-item>
            <!--          <el-menu-item index="3" class="el-menu-item">设置上级</el-menu-item>-->
            <el-menu-item index="4" class="el-menu-item">删除</el-menu-item>
            <!--          <el-menu-item index="5" class="el-menu-item">上移</el-menu-item>-->
            <!--          <el-menu-item index="6" class="el-menu-item">下移</el-menu-item>-->
          </el-menu>
        </el-card>
      </div>
      <!--登记密码对话框-->
      <el-dialog :visible="false">
        <el-form label-width="80px" :model="dialog.otherForm">
          <el-form-item label="证件类型" prop="type">
            <!--证号类型-->
            <el-select v-model="dialog.otherForm.type">
              <el-option
                v-for="item in dialog.typeOptions"
                :key="item.id"
                :value="item"
                :label="item.name"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="账号" prop="account">
            <!--账号-->
            <el-input placeholder="请输入账号" v-model="dialog.otherForm.account"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <!--密码-->
            <el-input placeholder="请输入密码" show-password v-model="dialog.otherForm.password"></el-input>
          </el-form-item>
          <el-form-item label="使用情况" prop="introduction">
            <!--使用情况-->
            <el-input
              type="textarea"
              v-model="dialog.otherForm.introduction"
              :rows="2"
              placeholder="请输入内容"
            />
          </el-form-item>
          <el-form-item label="到期时间" prop="expireTime">
            <!--到期时间-->
            <el-date-picker v-model="dialog.otherForm.expireTime" />
          </el-form-item>
          <el-form-item label="余额" prop="balance">
            <!--账号余额-->
            <el-input v-model="dialog.otherForm.balance" />
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <!--备注-->
            <el-input :rows="2" placeholder="请输入内容" v-model="dialog.otherForm.remark"></el-input>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  created () {
    this.requestOtherOption()
    this.list()
  },
  data () {
    return {
      pageTotal: 20,
      pageSize: 10,

      //文档id
      thirdpartDirId: '',
      dialog: {
        //表单数据
        otherForm: {
          //账号
          account: '',
          //余额
          balance: '',
          //到期时间
          expireTime: '',
          //使用情况
          introduction: '',
          //密码
          password: '',
          //备注
          remark: '',
          type: ''
        },
        typeOptions: [],
        otherFormRules: {
          //账号
          account: [
            { required: true, message: '请输入账号', trigger: 'blur' },
          ],
          //余额
          balance: [
            { required: true, message: '请输入账号', trigger: 'blur' },
          ],
          //到期时间
          expireTime: [
            { required: true, message: '请选择到期时间', trigger: 'change' }
          ],
          // //使用情况
          // introduction: [
          //   {required: true, message: '请输入账号', trigger: 'blur'},
          // ],
          //密码
          password: [
            { required: true, message: '请输入账号', trigger: 'blur' },
          ],
          //备注
          // remark: '',
          type: [
            { required: true, message: '请选择账号类型', trigger: 'change' },
          ]
        }
      },

      //右击菜单栏
      activeIndex: "0",
      //密码可见列表
      visiableIds: [],
      //表格对象
      tableData: [
        {
          id: 1,
          accountType: "账号类型",
          account: "账号类型",
          password: "密码",
          usage: "使用情况",
          dueTime: "到期时间",
          balance: "余额",
          updateTime: "更新时间",
          updater: "更新人",
          mark: "备注信息"
        },
        {
          id: 2,
          accountType: "账号类型",
          account: "账号类型",
          password: "密码",
          usage: "使用情况",
          dueTime: "到期时间",
          balance: "余额",
          updateTime: "更新时间",
          updater: "更新人",
          mark: "备注信息"
        }
      ],


      /** 以下变量是右击菜单的相关变量  ***/
      //右击的节点
      NODE: {},
      //右击节点的数据
      DATA: {},

      //右击菜单栏是否显示
      menuVisiable: false,
      //文件夹列表
      treeData: [
        {
          id: "1",
          label: "内部公司账号",
          children: [
            {
              id: "1-1",
              label: "18926144391"
            }, {
              id: "1-2",
              label: "18926144392"
            }, {
              id: "1-3",
              label: "18926144393"
            }, {
              id: "1-4",
              label: "18926144394"
            }, {
              id: "1-5",
              label: "18926144395"
            }
          ]
        },
        {
          id: "2",
          label: "外部项目账号",
          children: [{
            label: "18819450385"
          }]
        }
      ],

    }
  },
  methods: {
    //编辑
    editItem (item) {
      console.log("编辑", item)
    },
    //删除
    delItem (item) {
      console.log("删除", item)
    },
    //查看密码
    plaintext (item) {
      const index = this.visiableIds.indexOf(item.id);
      if (index == -1) {
        this.visiableIds.push(item.id)
      } else {
        this.visiableIds.splice(index, 1)
      }
      console.log("当前展开的：" + index, this.visiableIds)
      console.log("查看密码")

    },
    /**
     * 左侧菜单点击
     */
    leftClick (event, object, node, element) {
      console.log("左侧菜单单击")
      if (this.menuVisiable) {
        this.menuVisiable = false;
      }
      if (!node.isEdit) {
        //如果该节点不处于编辑状态的话，就实现点击跳转操作

      }
    },
    /***
     * 右键点击
     * @param event
     * @param object
     * @param node
     * @param element
     */
    rightClick (event, object, node, element) {
      /**
       * @node-contextmenu :当某一个节点被鼠标右键点击时会触发该事件 ，
       *                    共四个参数，依次为：
       *                    event,
       *                    object:传递给data属性的数组中该节点所对应的对象，
       *                    value:节点对应的Node、
       *                    element:节点组件本身
       */
      console.log("右击：")
      console.log("event:", event)
      console.log("object:", object)

      //对节点进行保存，以便右击是处理。
      this.NODE = node;
      this.DATA = object;

      this.menuVisiable = true;
      document.addEventListener('click', (e) => {
        this.menuVisiable = false;
        document.removeEventListener('click', (e) => {
          console.log("移除click事件")
        })
      })
      let menu = document.querySelector("#rightClickMenu");
      /* 菜单定位基于鼠标点击位置 */
      menu.style.left = event.clientX + 50 + "px";
      menu.style.top = event.clientY - 30 + "px";
      menu.style.position = "absolute"; // 为新创建的DIV指定绝对定位
      menu.style.width = 160 + "px";
    },
    /***
     * 右击菜单点击
     * @param index 点击索引， index=1开始
     * @param path
     */
    menuSelect (index, path) {
      console.log("右击菜单选择：", index, path)
      if (1 == index) {
        this.newAddNode(this.NODE, this.DATA)
      } else if (2 == index) {
        console.log("修改名称")
        this.editNode(this.NODE, this.DATA)
      } else if (3 == index) {
        console.log("设置上级")
      } else if (4 == index) {
        console.log("删除节点")
        this.delNode(this.NODE, this.DATA)
      } else if (5 == index) {
        console.log("上移")
      } else if (6 == index) {
        console.log("下移")
      }
    },
    /***
     * 新增子节点
     * @param node
     * @param data
     */
    newAddNode (node, data) {
      const level = node.level;
      console.log("新增节点", node)
      if (node.parent) {
        let parentNode = node.parent;
        //获取父节点的data:{lable,children}
        let pData = parentNode.data;
        if (pData instanceof Array) {
          //   这里是一级节点
          let children = data.children;
          let newChildNode = {
            label: "新节点"
          }
          children.push(newChildNode)
        } else {
          //数组Array
          let children = pData.children;
          let newChildNode = {
            label: "新节点"
          }
          children.push(newChildNode)
        }
      }
    },
    /**
     * 修改节点名称
     * @param node
     * @param data
     */
    editNode (node, data) {
      if (!node.isEdit) {//检测isEdit是否存在or是否为false
        this.$set(node, 'isEdit', true)
      }

      this.$nextTick(() => {
        console.log("更新通知")
        this.$refs['slotTreeInput' + data.id].focus()
      })
    },
    /***
     * 删除节点
     * @param NODE
     * @param DATA
     */
    delNode (node, data) {

      this.$confirm("确定删除‘" + data.label + "‘吗？").then(value => {
        // const level = node.level;
        // let parentNode = node.parent;
        // let pData = parentNode.data;
        // // 当level==1 这个时候这里是Array
        // if (pData instanceof Array) {
        //   const index = pData.indexOf(data);
        //   pData.splice(index, 1)
        // } else {
        //   let children = pData.children;
        //   const index = children.indexOf(data);
        //   children.splice(index, 1)
        // }
        this.$refs['tree'].remove(node)
      }, reason => {
        //  取消
      })

    },
    /***
     * 新建文件夹
     */
    newFolder () {
      let data = {
        id: 1003434,
        label: "新建文件夹"
      }
      this.treeData.push(data)
    },
    /***
     * 编辑状态的输入框失去焦点
     * @param node
     * @param data
     */
    nodeBlur (node, data) {
      console.log("失去焦点", node, data)
      if (node.isEdit) {
        this.$set(node, 'isEdit', false)
      }
    },

    /**
     等级密码
     */
    addAcount () {
      console.log('登记密码')
    },
    /***
     * 获取所属行业字典
     */
    requestOtherOption () {
      this.$http({
        url: '/api/pc/companyDict/getMap',
        method: 'get',
        params: {
          dictGroupCodeList: 'RISK_LEVEL,RISK_TYPE'
        }
      }).then(response => {
        if (1000 == response.code) {
          this.dialog.typeOptions = response.data.RISK_LEVEL;
        }
      }).catch(error => {
      })
    }
    /***
     * 新增账号
     * @param data
     *
     */
    , page (data) {
      this.$http({
        url: '/api/pc/thirdPartData/page',
        method: 'post',
        data: data
      }).then(response => {
        if (1000 == response.code) {
        }
      }).catch(error => {
      })
    },
    /***
     * 新增账号
     * @param data
     *
     */
    add (data) {
      this.$http({
        url: '/api/pc/thirdPartData/add',
        method: 'post',
        data: data
      }).then(response => {
        if (1000 == response.code) {
        }
      }).catch(error => {
      })
    },
    /***
     * 删除账号
     */
    delete (id) {
      this.$http({
        url: `/api/pc/thirdPartData/delete/${id}`,
        method: 'delete',
        data: {}
      }).then(response => {
        if (1000 == response.code) {
        }
      }).catch(error => {
      })
    },
    /***
     * 修改账号
     */
    update (data) {
      this.$http({
        url: '/api/pc/thirdPartData/update',
        method: 'put',
        data: data
      }).then(response => {
        if (1000 == response.code) {
        }
      }).catch(error => {
      })
    },


    /***
     * 新增文件夹
     * @param data
     * {
     *   "name": "string",
     *   "parentId": "string"
     * }
     */
    list () {
      this.$http({
        url: '/api/pc/thirdPartData/list',
        method: 'get',
      }).then(response => {
        if (1000 == response.code) {
        }
      }).catch(error => {
      })
    }, /***
       * 新增文件夹
       * @param data
       * {
       *   "name": "string",
       *   "parentId": "string"
       * }
       */
    addDir (data) {
      this.$http({
        url: '/api/pc/thirdPartData/addDir',
        method: 'post',
        data: data
      }).then(response => {
        if (1000 == response.code) {
        }
      }).catch(error => {
      })
    },
    /***
     * 删除文件夹
     * @param id
     */
    deleteDir (id) {
      this.$http({
        url: `/api/pc/thirdPartData/deleteDir/${id}`,
        method: 'delete',
        data: {}
      }).then(response => {
        if (1000 == response.code) {
        }
      }).catch(error => {
      })
    },
    /***
     * 移动文件夹
     * @param data
     *
     * index*  integer($int32)  父节点下的位置索引（1开始）
     * moveId*  string   移动节点id
     * parentId  string 父id（不传默认根下）
     */
    moveDir (data) {
      this.$http({
        url: "/api/pc/thirdPartData/moveDir",
        method: 'put',
        data: data
      }).then(response => {
        if (1000 == response.code) {
        }
      }).catch(error => {
      })
    },
    /***
     * 更新文件夹
     * @param data
     */
    updateDir (data) {
      this.$http({
        url: "/api/pc/thirdPartData/updateDir",
        method: 'put',
        data: data
      }).then(response => {
        if (1000 == response.code) {
        }
      }).catch(error => {
      })
    },


  }
}
</script>

<style scoped>
.box {
  display: flex;
  flex-direction: row;
  /*
    * nowrap :不换行
    * wrap ：换行，第一行在上方
    * wrap-reverse ： 换行，第一行在下方
    */
  flex-wrap: nowrap;
}

.card-float {
}

.left-card {
  width: 250px;
}

.right-card {
  margin-left: 20px;
  flex-grow: 1;
}

.el-menu {
  border-right: 0 !important;
}

.el-menu-item {
  height: 40px;
  line-height: 40px;
}

/*.custom-tree-node{*/
/*  padding-top: 0 !important;*/
/*  line-height: 80px;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/views/system-manage/OtherServiceAccounts.vue